module.exports = __webpack_public_path__ + "img/rarr-icon.5e5b160b.svg";